import React, { useReducer } from 'react'
import { ApolloProvider } from '@apollo/react-hooks'
import useCombinedReducers from 'use-combined-reducers'
import fireGQL from 'api/firebase'

import { GlobalTheme } from './global/GlobalTheme'
import { IResult } from 'models'
import { StateContext, DispatchContext } from 'store/contexts'
import {
  initialScreen,
  initialQuestions,
  initialResponses,
  screenReducer,
  questionsReducer,
  responsesReducer,
  IQuestionsState,
  IScreenState,
  IResponsesState,
  uiReducer,
  initialUi,
  IUiState,
  IProductsState,
  productsReducer,
  initialProducts,
} from 'store/reducers'
import Action from 'store/Action'
import { resultReducer, initialResult } from './store/reducers'
import StartScreen from 'containers/StartScreen'
import QuestionsScreen from 'containers/QuestionsScreen'
import HandScreen from 'containers/HandScreen'
import DigestScreen from 'containers/DigestScreen'
import { Layout, SubscriptionBox } from 'components'

const renderScreen = (screen: string) => {
  switch (screen) {
    case 'StartScreen':
      return <StartScreen />
    case 'QuestionsScreen':
      return <QuestionsScreen />
    case 'HandScreen':
      return <HandScreen />
    case 'DigestScreen':
      return <DigestScreen />
    default:
      return <StartScreen />
  }
}

export interface IAppState {
  ui: IUiState
  screen: IScreenState
  questions: IQuestionsState
  products: IProductsState
  responses: IResponsesState
  result: IResult
}

const App = () => {
  // initialize root reducers
  const [state, dispatch] = useCombinedReducers<IAppState, Action<any>>({
    ui: useReducer(uiReducer, initialUi),
    screen: useReducer(screenReducer, initialScreen),
    questions: useReducer(questionsReducer, initialQuestions),
    products: useReducer(productsReducer, initialProducts),
    responses: useReducer(responsesReducer, initialResponses),
    result: useReducer(resultReducer, initialResult),
  })

  const currentScreen = state.screen

  return (
    <GlobalTheme>
      <ApolloProvider client={fireGQL}>
        <DispatchContext.Provider value={dispatch}>
          <StateContext.Provider value={state}>
            <Layout>{renderScreen(currentScreen)}</Layout>
            {/* render the subscription box here, due to it's using universal jquery code to control the embedded form submission, and ONLY works when initially load it on the screen */}
            <SubscriptionBox />
          </StateContext.Provider>
        </DispatchContext.Provider>
      </ApolloProvider>
    </GlobalTheme>
  )
}

export default App
